'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Error = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    padding: 15px;\n    overflow: auto;\n    box-sizing: border-box;\n    color: red;\n'], ['\n    padding: 15px;\n    overflow: auto;\n    box-sizing: border-box;\n    color: red;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Container = require('./Container');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledError = _styledComponents2.default.div(_templateObject);

var Error = exports.Error = function Error(_ref) {
    var children = _ref.children;

    return _react2.default.createElement(
        _Container.Container,
        null,
        _react2.default.createElement(
            StyledError,
            null,
            children
        )
    );
};

Error.propTypes = {
    children: _propTypes2.default.node
};